{
  "moreActions": "更多動作",
  "unavailable": "無法使用，展開以取得詳細資料"
}
